import React, { useRef, useEffect, useState } from "react";
import { Props as InputProps } from "react-input-mask";

import { useField } from "@unform/core";

import * as S from "./styles";

interface Props extends InputProps {
  name: string;
  type?: string;
  className?: string;
  label?: string;
  labelStyle?: Record<string, any>;
  inputStyle?: Record<string, any>;
  containerStyle?: Record<string, any>;
  required?: boolean;
  isLoading?: boolean;
}

export function InputMask({
  name,
  label,
  type = "text",
  className = "field-container",
  labelStyle = {},
  inputStyle = {},
  containerStyle = {},
  required = false,
  isLoading = false,
  ...rest
}: Props) {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  // Estado para controlar o valor do input
  const [value, setValue] = useState(
    defaultValue !== undefined && defaultValue !== null
      ? String(defaultValue)
      : ""
  );

  useEffect(() => {
    setValue(
      defaultValue !== undefined && defaultValue !== null
        ? String(defaultValue)
        : ""
    );
  }, [defaultValue]);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue: () => value,
      setValue: (_ref: any, val: string) => {
        setValue(val);
      },
      clearValue: () => setValue(""),
    });
  }, [fieldName, registerField, value]);

  const Label = () => (
    <S.FieldLabel htmlFor={fieldName} style={labelStyle}>
      {label}
      {required && <span>*</span>}
    </S.FieldLabel>
  );

  const Error = () => <S.FieldError>{error}</S.FieldError>;

  return (
    <S.FieldContainer style={containerStyle} className={className}>
      {label && <Label />}
      <S.InputMask
        ref={inputRef}
        type={type}
        id={fieldName}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        style={inputStyle}
        {...rest}
      />
      {isLoading && <S.IsLoading />}
      {error && <Error />}
    </S.FieldContainer>
  );
}
